module.exports = __webpack_public_path__ + "img/vouchers10010.74cf8a95.png";